import React from 'react';
import s from './Heading.module.css';
import { Language } from '../Language';

export const Heading = ({ options }) => (
  <Language {...options} tagName="h2" className={s.heading} />
);
